import { useSyncExternalStore } from 'react';
import { sessionStore } from './session';
import type { CurrentUser, Organisation, SessionState } from './store';

/**
 * Session state, for components (P0-WEB-07).
 *
 * No context provider: there is exactly one session per browser tab, and the
 * store lives outside React because loaders read it too. A provider would add a
 * second way to reach the same value, and the two would eventually disagree.
 */
export function useSession(): SessionState {
  return useSyncExternalStore(
    sessionStore.subscribe,
    sessionStore.getSnapshot,
    sessionStore.getSnapshot,
  );
}

/** Who the session belongs to, once the bootstrap has resolved (P0-PLAT-20). */
export function useCurrentUser(): CurrentUser | undefined {
  return useSession().user;
}

/** The organisation every request is acting for, resolved to its record. */
export function useSelectedOrganisation(): Organisation | undefined {
  const { organisations, organisationId } = useSession();
  return organisations.find((organisation) => organisation.id === organisationId);
}
